import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import {
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCol,
  MDBDataTable,
  MDBDataTableV5,
  MDBRow,
} from "mdbreact";
import dayjs from "dayjs";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Input,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap";
import {
  Popover,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useGetFilter from "../../helpers/hooks/useGetFilter";

function LoanList(props) {
  const [showModal, setShowModal] = useState(false);

  //   by atiq................

  const [popoverOpen, setPopoverOpen] = useState({
    loanId: false,
    date: false,
    name: false,
    cnic: false,
    phoneNumber: false,
    city: false,
    score: false,
    response: false,
    status: false,
  });

  const togglePopover = (field) => {
    setPopoverOpen((prev) => ({
      ...Object.fromEntries(
        Object.keys(prev).map((key) => [
          key,
          key === field ? !prev[key] : false,
        ])
      ),
    }));
  };

  // const [loanId_PopoverOpen, setLoanIdPopoverOpen] = useState(false);
  // const [date_PopoverOpen, setDatePopoverOpen] = useState(false);
  // const [name_PopoverOpen, setNamePopoverOpen] = useState(false);
  // const [cnic_PopoverOpen, setCnicPopoverOpen] = useState(false);
  // const [phonNumber_PopoverOpen, setPhonNumberPopoverOpen] = useState(false);
  // const [city_PopoverOpen, setCityPopoverOpen] = useState(false);
  // const [score_PopoverOpen, setScorePopoverOpen] = useState(false);
  // const [response_PopoverOpen, setResponsePopoverOpen] = useState(false);
  // const [status_PopoverOpen, setStatusPopoverOpen] = useState(false);

  // const toggleLoanId_Popover = () => setLoanIdPopoverOpen(!loanId_PopoverOpen);
  // const toggleDate_Popover = () => setDatePopoverOpen(!date_PopoverOpen);
  // const toggleName_Popover = () => setNamePopoverOpen(!name_PopoverOpen);
  // const toggleCnic_Popover = () => setCnicPopoverOpen(!cnic_PopoverOpen);
  // const togglePhonNumber_Popover = () =>setPhonNumberPopoverOpen(!phonNumber_PopoverOpen);
  // const toggleCity_Popover = () => setCityPopoverOpen(!city_PopoverOpen);
  // const toggleScore_Popover = () => setScorePopoverOpen(!score_PopoverOpen);
  // const toggleResponse_Popover = () =>setResponsePopoverOpen(!response_PopoverOpen);
  // const toggleStatus_Popover = () => setStatusPopoverOpen(!status_PopoverOpen);
  // const togglePopover = () => setPopoverOpen(!popoverOpen);

  const { status } = useParams();

  console.log(status);

  const loanStatus = [
    {
      value: "Rejected By Bank",
      color: "#fbe7e9",
      fontColor:"#d84848",
      status: -2,
    },
    {
      value: "Rejected By Beythak",
      color: "#ff005b",
      fontColor:"#d84848",
      status: -1,
    },
    {
      value: "Pending Beythak Approval",
      color: "#fff1e2",
      fontColor:"#f29d41",
      status: 0,
    },
    {
      value: "Pending Bank Approval",
      color: "#fff1e2",
      fontColor:"#f29d41",
      status: 1,
    },
    {
      value: "Approved By Bank",
      color: "#ddf8ee",
      fontColor:"#25a581",
      status: 2,
    },
    {
      value: "Under Review",
      color: "#f6f7fa",
      fontColor:"#727272",
      status: 3,
    },
    {
      value: "All",
      status: "",
    },
  ];

  const bankAdmin = JSON.parse(localStorage.getItem("bankAdmin"));

  // const ads = []
  const columns = [
    {
      label: "Loan ID",
      field: "loanId",
      sort: "disabled",
      width: 150,
    },
    {
      label: "Date",
      field: "date",
      sort: "disabled",
      width: 150,
    },
    {
      label: "Name",
      field: "name",
      sort: "asc",
      width: 150,
    },
    {
      label: "CNIC",
      field: "cnic",
      sort: "asc",
      width: 150,
    },
    {
      label: "Phone Number",
      field: "phoneNumber",
      sort: "asc",
      width: 270,
    },
    {
      label: "City",
      field: "city",
      sort: "asc",
      width: 270,
    },
    {
      label: "Loan Amount",
      field: "loanAmount",
      sort: "asc",
      width: 270,
    },
    
    {
      label: "Score",
      field: "score",
      sort: "asc",
      width: 270,
    },
    {
      label: "Changes Response",
      field: "response",
      sort: "disabled",
      width: 270,
    },
    {
      label: "Loan Status",
      field: "status",
      sort: "asc",
      width: 270,
    },
    {
      label: "Applications",
      field: "applications",
      sort: "disabled",
      width: 270,
    },
    {
      label: bankAdmin ? "User Info" : "Credit Score",
      field: "creditScore",
      sort: "disabled",
      width: 270,
    },
    {
      label: "Financial Statements",
      field: "financialStatements",
      sort: "disabled",
      width: 270,
    },
  ];

  // States
  const [isLoading, setIsLoading] = useState(false);
  const [isBool, setIsBool] = useState(false);
  const [statusNo, setStatusNo] = useState("");
  const [statusValue, setStatusValue] = useState(status);
  const [tableData, setTableData] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);

  // Hooks
  const [data, error, loading, call] = useGetFilter(
    `get_loan_applications${
      JSON.parse(localStorage.getItem("bankAdmin")) ? "?bank_status=1" : ""
    }`,
    "loan"
  );
  console.log("data",data);
  console.log("tablidata",tableData);

  const loanStatusMappings = {
    0: "Pending Beythak Approval",
    "-1": "Rejected By Beythak",
    3: "Under Review",
    "-2": "Rejected By Bank",
    2: "Approved By Bank",
    1: "Pending Bank Approval",
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [searchCreatedAt, setSearchCreatedAt] = useState("");
  const [searchName, setSearchName] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [searchCNIC, setSearchCNIC] = useState("");
  const [searchCell, setSearchCell] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [searchLoanStatus, setSearchLoanStatus] = useState("");
  const [searchScore, setSearchScore] = useState("");
  const [searchResponse, setSearchResponse] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (field, value) => {
    if (field === "loanId") {
      setSearchTerm(value);
    } else if (field === "createdAt") {
      setSearchCreatedAt(value);
    } else if (field === "name") {
      setSearchName(value);
    } else if (field === "cnic") {
      setSearchCNIC(value);
    } else if (field === "cellnum") {
      setSearchCell(value);
    } else if (field === "city") {
      setSearchCity(value);
    } else if (field === "status") {
      setSearchLoanStatus(value);
    } else if (field === "score") {
      setSearchScore(value);
    } else if (field === "response") {
      setSearchResponse(value);
    }
  };

  // const [filteredData, setFilteredData] = useState("");
  // useEffect(() => {
  //   if (tableData?.length > 0) {
  //     setFilteredData(
  //       tableData?.filter((x) => {
  //         const loanIdMatch = x?.loan_application?.loan_id
  //           .toLowerCase()
  //           .includes(searchTerm.toLowerCase());
  //         const createdAtMatch = moment(x?.loan_application?.createdAt)
  //           .format("DD-MM-YYYY")
  //           .toLowerCase()
  //           .includes(searchCreatedAt.toLowerCase());
  //         const nameMatch = x?.user_data?.name
  //           .toLowerCase()
  //           .includes(searchName.toLowerCase());
  //         const cnicMatch = x?.loan_application?.cnic.includes(searchCNIC);
  //         const phoneMatch = x?.user_data?.phone.includes(searchCell);
  //         const cityMatch = x?.user_data?.city
  //           .toLowerCase()
  //           .includes(searchCity.toLowerCase());
  //         const loanStatusMatch = loanStatusMappings[
  //           x?.loan_application?.loan_status
  //         ]
  //           .toLowerCase()
  //           .includes(searchLoanStatus.toLowerCase());
  //         const scoreMatch =
  //           `${x.loan_application.loan_grade}-${x.loan_application.loan_score}`
  //             .toLowerCase()
  //             .includes(searchScore.toLowerCase());
  //         const loanAmountMatch = (
  //           x?.loan_application?.preferred_loan_amount || 0
  //         )
  //           .toLocaleString("en-US", { maximumFractionDigits: 0 })
  //           .includes(
  //             searchLoanAmount.toLocaleString("en-US", {
  //               maximumFractionDigits: 0,
  //             })
  //           );

  //         const responseMatch =
  //           (x?.loan_application?.farmer_response === null &&
  //             !x?.loan_application?.ismodified &&
  //             "N/A") ||
  //           (x?.loan_application?.farmer_response === null &&
  //             x?.loan_application?.ismodified &&
  //             "Pending...") ||
  //           (x?.loan_application?.farmer_response === true &&
  //             !x?.loan_application?.ismodified &&
  //             "Accepted") ||
  //           (x?.loan_application?.farmer_response === false &&
  //             !x?.loan_application?.ismodified &&
  //             "Rejected") ||
  //           "";

  //         const responseTextMatch = responseMatch
  //           .toLowerCase()
  //           .includes(searchResponse.toLowerCase());

  //         const combinedSearchTerm = `${x?.loan_application?.loan_id} ${moment(
  //           x?.loan_application?.createdAt
  //         ).format("DD-MM-YYYY")} ${x?.user_data?.name} ${
  //           x?.loan_application?.cnic
  //         } ${x?.user_data?.phone} ${x?.user_data?.city} ${
  //           loanStatusMappings[x?.loan_application?.loan_status]
  //         } ${x.loan_application.loan_grade}-${x.loan_application.loan_score} ${
  //           (x?.loan_application?.farmer_response === null &&
  //             !x?.loan_application?.ismodified &&
  //             "N/A") ||
  //           (x?.loan_application?.farmer_response === null &&
  //             x?.loan_application?.ismodified &&
  //             "Pending...") ||
  //           (x?.loan_application?.farmer_response === true &&
  //             !x?.loan_application?.ismodified &&
  //             "Accepted") ||
  //           (x?.loan_application?.farmer_response === false &&
  //             !x?.loan_application?.ismodified &&
  //             "Rejected") ||
  //           ""
  //         }`.toLowerCase();

  //         const searchTerms = searchQuery.toLowerCase().split(" ");

  //         return (
  //           loanIdMatch &&
  //           createdAtMatch &&
  //           nameMatch &&
  //           cnicMatch &&
  //           phoneMatch &&
  //           cityMatch &&
  //           loanStatusMatch &&
  //           scoreMatch &&
  //           responseTextMatch &&
  //           loanAmountMatch &&
  //           searchTerms.every((term) => combinedSearchTerm.includes(term))
  //         );
  //       })
  //     );
  //   }
  // }, [tableData]);


  const filteredData = tableData.filter((x) => {
    const loanIdMatch = x?.loan_application?.loan_id
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const createdAtMatch = moment(x?.loan_application?.createdAt)
      .format("DD-MM-YYYY")
      .toLowerCase()
      .includes(searchCreatedAt.toLowerCase());
    const nameMatch = x?.user_data?.name
      .toLowerCase()
      .includes(searchName.toLowerCase());
    const cnicMatch = x?.loan_application?.cnic.includes(searchCNIC);
    const phoneMatch = x?.user_data?.phone.includes(searchCell);
    const cityMatch = x?.user_data?.city
      .toLowerCase()
      .includes(searchCity.toLowerCase());
    const loanStatusMatch = loanStatusMappings[x?.loan_application?.loan_status]
      .toLowerCase()
      .includes(searchLoanStatus.toLowerCase());
    const scoreMatch =
      `${x.loan_application.loan_grade}-${x.loan_application.loan_score}`
        .toLowerCase()
        .includes(searchScore.toLowerCase());

    const responseMatch =
      (x?.loan_application?.farmer_response === null &&
        !x?.loan_application?.ismodified &&
        "N/A") ||
      (x?.loan_application?.farmer_response === null &&
        x?.loan_application?.ismodified &&
        "Pending...") ||
      (x?.loan_application?.farmer_response === true &&
        !x?.loan_application?.ismodified &&
        "Accepted") ||
      (x?.loan_application?.farmer_response === false &&
        !x?.loan_application?.ismodified &&
        "Rejected") ||
      "";

    const responseTextMatch = responseMatch
      .toLowerCase()
      .includes(searchResponse.toLowerCase());

    const combinedSearchTerm = `${x?.loan_application?.loan_id} ${moment(
      x?.loan_application?.createdAt
    ).format("DD-MM-YYYY")} ${x?.user_data?.name} ${
      x?.loan_application?.cnic
    } ${x?.user_data?.phone} ${x?.user_data?.city} ${
      loanStatusMappings[x?.loan_application?.loan_status]
    } ${x.loan_application.loan_grade}-${x.loan_application.loan_score} ${
      (x?.loan_application?.farmer_response === null &&
        !x?.loan_application?.ismodified &&
        "N/A") ||
      (x?.loan_application?.farmer_response === null &&
        x?.loan_application?.ismodified &&
        "Pending...") ||
      (x?.loan_application?.farmer_response === true &&
        !x?.loan_application?.ismodified &&
        "Accepted") ||
      (x?.loan_application?.farmer_response === false &&
        !x?.loan_application?.ismodified &&
        "Rejected") ||
      ""
    }`.toLowerCase();

    const searchTerms = searchQuery.toLowerCase().split(" ");

    return (
      loanIdMatch &&
      createdAtMatch &&
      nameMatch &&
      cnicMatch &&
      phoneMatch &&
      cityMatch &&
      loanStatusMatch &&
      scoreMatch &&
      responseTextMatch &&
      searchTerms.every((term) => combinedSearchTerm.includes(term))
    );
  });

  const handleGlobalSearch = (searchValue) => {
    setSearchQuery(searchValue);
  };

  // Functions

  const changeStatus = (e) => {
    setStatusValue(e.target.value);
    setTableData([]);
  };

  useEffect(() => {
    if (localStorage.getItem("bankAdmin")) {
      call();
    }
    for (let x of loanStatus) {
      if (x.value === statusValue) {
        // console.log(x.value === statusValue)
        setStatusNo(x.status);
        call(x.status).then((response) => {
          console.log("response dekho pehle", response);
        });
      }
    }
  }, [statusValue]);

  useEffect(() => {
    if (data) {
      setDataLoading(false);
      setTableData(data.reverse());
    }
  }, [data]);

  return (
    <React.Fragment>
      <Container fluid>
        <div className="page-content">
          <Card>
            <CardBody>
              {loading ? (
                <div className="text-center">
                  <Spinner className="mr-2" color="primary" />
                </div>
              ) : (
                <div>
                  {!bankAdmin && (
                    <MDBRow className="d-flex justify-content-end mb-2">
                      <MDBCol xs="4" className="mr-4">
                        <Input
                          type="text"
                          placeholder="Search..."
                          onChange={(e) => handleGlobalSearch(e.target.value)}
                          style={{width:"400px", borderRadius:"10px"}}
                        />
                      </MDBCol>

                      <MDBCol xs="4" className="mr-3">
                        <MDBCardText>Application status:</MDBCardText>
                      </MDBCol>
                      <MDBCol xs="4" className="mr-4">
                        <Input
                          type={"select"}
                          className="text-muted"
                          value={statusValue}
                          onChange={changeStatus}
                          style={{width:"70px", borderRadius:"10px"}}
                        >
                          {loanStatus.map((x) => {
                            // console.log(x.value, x.status)
                            return (
                              <option key={x.value} value={x.value}>
                                {x.value}
                              </option>
                            );
                          })}
                        </Input>
                      </MDBCol>
                    </MDBRow>
                  )}

                  <MDBCard>
                    <MDBCardBody id="data-table">
                      {/* {!dataLoading && ( */}
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <i
                                  id="ScheduleUpdateIcon"
                                  className="ri-search-line"
                                  // onClick={toggleLoanId_Popover}
                                  onClick={() => togglePopover("loanId")}
                                  style={{ cursor: "pointer" }}
                                >
                                  {" "}
                                </i>{" "}
                                Loan ID
                                <Popover
                                  placement="bottom"
                                  // isOpen={loanId_PopoverOpen}
                                  isOpen={popoverOpen.loanId}
                                  target="ScheduleUpdateIcon"
                                  // toggle={toggleLoanId_Popover}
                                  toggle={() => togglePopover("loanId")}
                                >
                                  <PopoverBody>
                                    <Input
                                      type="text"
                                      placeholder="Search Loan ID"
                                      onChange={(e) =>
                                        handleSearch("loanId", e.target.value)
                                      }
                                    />
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="DateSearchIcon"
                                  className="ri-search-line"
                                  // onClick={toggleDate_Popover}
                                  onClick={() => togglePopover("date")}
                                  style={{ cursor: "pointer" }}
                                >
                                  {" "}
                                </i>{" "}
                                Date
                                <Popover
                                  placement="bottom"
                                  // isOpen={date_PopoverOpen}
                                  isOpen={popoverOpen.date}
                                  target="DateSearchIcon"
                                  // toggle={toggleDate_Popover}
                                  toggle={() => togglePopover("date")}
                                >
                                  <PopoverBody>
                                    <Input
                                      type="text"
                                      placeholder="Search By Date"
                                      onChange={(e) =>
                                        handleSearch(
                                          "createdAt",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </PopoverBody>
                                </Popover>
                              </th>

                              <th>
                                <i
                                  id="NameSearchIcon"
                                  className="ri-search-line"
                                  // onClick={toggleName_Popover}
                                  onClick={() => togglePopover("name")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Name
                                <Popover
                                  placement="bottom"
                                  // isOpen={name_PopoverOpen}
                                  isOpen={popoverOpen.name}
                                  target="NameSearchIcon"
                                  // toggle={toggleName_Popover}
                                  toggle={() => togglePopover("name")}
                                >
                                  <PopoverBody>
                                    <Input
                                      type="text"
                                      placeholder="Search name"
                                      onChange={(e) =>
                                        handleSearch("name", e.target.value)
                                      }
                                    />
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="CNICSearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("cnic")}
                                  // onClick={toggleCnic_Popover}
                                  style={{ cursor: "pointer" }}
                                >
                                  {" "}
                                </i>{" "}
                                CNIC
                                <Popover
                                  placement="bottom"
                                  // isOpen={cnic_PopoverOpen}
                                  isOpen={popoverOpen.cnic}
                                  target="CNICSearchIcon"
                                  // toggle={toggleCnic_Popover}
                                  toggle={() => togglePopover("cnic")}
                                >
                                  <PopoverBody>
                                    <Input
                                      type="text"
                                      placeholder="Search CNIC"
                                      onChange={(e) =>
                                        handleSearch("cnic", e.target.value)
                                      }
                                    />
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="PhoneNumberSearchIcon"
                                  className="ri-search-line"
                                  // onClick={togglePhonNumber_Popover}
                                  onClick={() => togglePopover("phoneNumber")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Phone Number
                                <Popover
                                  placement="bottom"
                                  // isOpen={phonNumber_PopoverOpen}
                                  isOpen={popoverOpen.phoneNumber}
                                  target="PhoneNumberSearchIcon"
                                  // toggle={togglePhonNumber_Popover}
                                  toggle={() => togglePopover("phoneNumber")}
                                >
                                  <PopoverBody>
                                    <Input
                                      type="text"
                                      placeholder="Search by phone no."
                                      onChange={(e) =>
                                        handleSearch("cellnum", e.target.value)
                                      }
                                    />
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="CitySearchIcon"
                                  className="ri-search-line"
                                  // onClick={toggleCity_Popover}
                                  onClick={() => togglePopover("city")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                City
                                <Popover
                                  placement="bottom"
                                  // isOpen={city_PopoverOpen}
                                  isOpen={popoverOpen.city}
                                  target="CitySearchIcon"
                                  // toggle={toggleCity_Popover}
                                  toggle={() => togglePopover("city")}
                                >
                                  <PopoverBody>
                                    <Input
                                      type="text"
                                      placeholder="Search by city"
                                      onChange={(e) =>
                                        handleSearch("city", e.target.value)
                                      }
                                    />
                                  </PopoverBody>
                                </Popover>
                              </th>

                              <th>Loan Amount</th>
                              <th>
                                <i
                                  // id="StatusSearchTooltip"
                                  id="StatusSearchIcon"
                                  className="ri-search-line"
                                  // onClick={() => setShowSearch(!showSearch)}
                                  onClick={() => togglePopover("status")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Status
                                {/* <UncontrolledTooltip */}
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.status}
                                  target="StatusSearchIcon"
                                  toggle={() => togglePopover("status")}
                                  // trigger="click"
                                  // style={{
                                  //   backgroundColor: "white",
                                  //   width: "120px",
                                  // }}
                                >
                                  {/* <input */}
                                  <Input
                                    type="text"
                                    placeholder="Search by status"
                                    onChange={(e) =>
                                      handleSearch("status", e.target.value)
                                    }
                                    // style={{
                                    //   border: "none",
                                    //   outline: "none",
                                    //   borderRadius: "4px",
                                    //   width: "100px",
                                    // }}
                                  />
                                  {/* </UncontrolledTooltip> */}
                                </Popover>
                              </th>

                              <th>
                                <i
                                  id="ScoreSearchIcon"
                                  className="ri-search-line"
                                  // onClick={toggleScore_Popover}
                                  onClick={() => togglePopover("score")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Score
                                <Popover
                                  placement="bottom"
                                  // isOpen={score_PopoverOpen}
                                  isOpen={popoverOpen.score}
                                  target="ScoreSearchIcon"
                                  // toggle={toggleScore_Popover}
                                  toggle={() => togglePopover("score")}
                                >
                                  <PopoverBody>
                                    <Input
                                      type="text"
                                      placeholder="Search by score"
                                      onChange={(e) =>
                                        handleSearch("score", e.target.value)
                                      }
                                    />
                                  </PopoverBody>
                                </Popover>
                              </th>

                              <th>
                                <i
                                  id="ResponseSearchIcon"
                                  className="ri-search-line"
                                  // onClick={toggleResponse_Popover}
                                  onClick={() => togglePopover("response")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Changes Response
                                <Popover
                                  placement="bottom"
                                  // isOpen={response_PopoverOpen}
                                  isOpen={popoverOpen.response}
                                  target="ResponseSearchIcon"
                                  // toggle={toggleResponse_Popover}
                                  toggle={() => togglePopover("response")}
                                >
                                  <PopoverBody>
                                    <Input
                                      type="text"
                                      placeholder="Search by response"
                                      onChange={(e) =>
                                        handleSearch("response", e.target.value)
                                      }
                                    />
                                  </PopoverBody>
                                </Popover>
                              </th>











                              <th>Applications</th>
                              <th>Credit Score</th>
                              <th>Financial Statements</th>
                            </tr>
                          </thead>


                          <tbody>
                            {filteredData.length === 0 ? (
                              <tr>
                                <td colSpan="13" className="text-center">
                                  Record Not Found
                                </td>
                              </tr>
                            ) : (
                              //  {
                              filteredData.map((x, index) => (
                                <tr key={index}>
                                  <td style={{width:"40%"}}>{x?.loan_application?.loan_id}</td>
                                  <td>
                                    {moment(
                                      x?.loan_application?.createdAt
                                    ).format("DD-MM-YYYY")}
                                  </td>
                                  <td>{x?.user_data?.name}</td>
                                  <td>{x?.loan_application?.cnic}</td>
                                  <td>{x?.user_data?.phone}</td>
                                  <td>{x?.user_data?.city}</td>
                                  <td>
                                    Rs.
                                    {(
                                      x?.loan_application
                                        ?.preferred_loan_amount || 0
                                    ).toLocaleString("en-US", {
                                      maximumFractionDigits: 0,
                                    })}
                                    /-
                                  </td>
                                  <td>
                                    <Badge
                                      className="font-size-14"
                                      style={{
                                        height: "30%",
                                        backgroundColor:
                                          loanStatus[
                                            +x?.loan_application?.loan_status +
                                              2
                                          ]["color"],
                                          color:
                                          loanStatus[
                                            +x?.loan_application?.loan_status +
                                              2
                                          ]["fontColor"],
                                          padding:"6px"
                                      }}
                                    >
                                      {
                                        loanStatus[
                                          +x?.loan_application?.loan_status + 2
                                        ]["value"]
                                      }
                                    </Badge>
                                  </td>
                                  <td>{`${x.loan_application.loan_grade}-${x.loan_application.loan_score}`}</td>
                                  <td>
                                    {x?.loan_application?.farmer_response ===
                                    null
                                      ? x?.loan_application?.ismodified ===
                                        false
                                        ? "N/A"
                                        : "Pending..."
                                      : x?.loan_application?.farmer_response ===
                                        true
                                      ? x?.loan_application?.ismodified ===
                                        false
                                        ? "Accepted"
                                        : ""
                                      : x?.loan_application?.farmer_response ===
                                        false
                                      ? x?.loan_application?.ismodified ===
                                        false
                                        ? "Rejected"
                                        : ""
                                      : ""}
                                  </td>
                                  <td>
                                    <Link
                                      to={{
                                        pathname: `/loan-detail/${x?.loan_application?._id}/${x?.loan_application?.loan_id}`,
                                        state: x?.loan_application,
                                      }}
                                      className="waves-effect waves-light mr-1"
                                      style={{color:"#0000ee", width:"120px"}}
                                    >
                                      View Application
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={{
                                        pathname: `/loan-analytics/${x?.loan_application?.loan_id}/${x?.loan_application?._id}`,
                                      }}
                                      className="waves-effect waves-light mr-1"
                                      style={{color:"#0000ee", width:"120px"}}
                                    >
                                      {bankAdmin
                                        ? "View User Info"
                                        : "View Credit Score"}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={{
                                        pathname: `/loan-financials/${x?.loan_application?.loan_id}/${x?.loan_application?._id}`,
                                      }}
                                      className="waves-effect waves-light mr-1"
                                      style={{color:"#0000ee",width:"140px"}}
                                    >
                                      View Loan Financials
                                    </Link>
                                  </td>
                                </tr>
                              ))
                            )}
                            {/* } */}
                          </tbody>
                        </table>
                      </div>
                      {/* )}  */}
                    </MDBCardBody>
                  </MDBCard>
                </div>
              )}
            </CardBody>
          </Card>
          <Card>
            <CardBody>{loading ? (
              <div className='text-center'>
                <Spinner className='mr-2' color='primary' />
              </div>
            ) :
              <MDBCard>
                <MDBCardBody id='data-table'>
                  <MDBDataTable
                    btn
                    responsive
                    bordered
                    // conditionalRowStyles={[{when: }]}
                    data={{
                      columns: columns,
                      rows: data?.reverse()?.map((x) => {
                        // console.log({ x })
                        return ({
                          loanId: x?.loan_application?.loan_id,
                          date: moment(x?.loan_application?.createdAt).format('DD-MM-YYYY'),
                          name: x?.user_data?.name,
                          cnic: x?.loan_application?.cnic,
                          phoneNumber: x?.user_data?.phone,
                          city: x?.user_data?.city,
                          loanAmount: 'Rs. ' + (x?.loan_application?.preferred_loan_amount || 0).toLocaleString('en-US', {
                            maximumFractionDigits: 0,
                          })+'/-',
                          // ? <CurrencyFormat value={x.loan_application.preferred_loan_amount} displayType={'text'}
                          //   // style={{ color: x.loan_application?.user_response && !bankAdmin && 'blue' }}
                          //   thousandSeparator={true} prefix='Rs. ' suffix='/-' /> : '-',
                          status: <Badge className='font-size-14' style={{ height: '30%', backgroundColor: loanStatus[+x?.loan_application?.loan_status + 2]['color'] }}>
                            {loanStatus[+x?.loan_application?.loan_status + 2]['value']}</Badge>,
                          score: `${x.loan_application.loan_grade}-${x.loan_application.loan_score}`,
                          // grade: x.loan_application.loan_grade,
                          applications: < Link to={{ pathname: `/loan-detail/${x?.loan_application?._id}/${x?.loan_application?.loan_id}`, state: x?.loan_application }} className='waves-effect waves-light mr-1' color='primary'>View Application</Link>,
                          creditScore: <Link to={{ pathname: `/loan-analytics/${x?.loan_application?.loan_id}/${x?.loan_application?._id}` }} className='waves-effect waves-light mr-1' color='primary'>{bankAdmin ? 'View User Info' : 'View Credit Score'}</Link>
                          // actions: (
                          //   <>
                          //     <Button
                          //       size='sm'}
                          //       color='warning'
                          //     // onClick={() => props.viewBids(x)}
                          //     >
                          //       View Bids
                          //     </Button>
                          //   </>
                          // ),
                        })
                      }).reverse(),
                    }}
                  />
                </MDBCardBody>
              </MDBCard>}</CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
}

export default LoanList;
